import { MessageType } from './Enums';
import { toast } from 'react-toastify';

const DEFAULT_OPTIONS = {
    closeOnClick: true,
    autoClose: 5000,
    position: 'top-right',
};

// General message function to handle all types
const showToast = (message, type, customOptions) => {
    const options = { ...DEFAULT_OPTIONS, ...customOptions };
    toast[type](message, options);
};

// Main hook to return specific message type functions
const useMessage = () => {
    const info = (message, customOptions = {}) => {
        showToast(message, 'info', customOptions);
    };

    const success = (message, customOptions = {}) => {
        showToast(message, 'success', customOptions);
    };

    const warning = (message, customOptions = {}) => {
        showToast(message, 'warning', customOptions);
    };

    const error = (message, customOptions = {}) => {
        showToast(message, 'error', customOptions);
    };

    const custom = (message, customOptions = {}) => {
        showToast(message, 'default', customOptions); // Default handles custom cases
    };

    return {
        info,
        success,
        warning,
        error,
        custom,
    };
};

export default useMessage;
